<template>
    <div class="file-upload-section">
        <div class="d-flex">
            <h2>{{ t("Related Files") }}</h2>
            <v-btn
                v-if="hasPermissionForAction(PermissionsConstants.WORK_ORDER, PermissionsConstants.UPLOAD)"
                class="px-2 ml-4"
                color="bal-red"
                dark
                small
                style="min-width: 0;"
                @click.stop="handleFileInputClick"
            >
                <v-icon>add</v-icon>
            </v-btn>

            <input multiple type="file" ref="fileInput" style="display: none" @change="handleFileUpload" />
        </div>

        <v-list>
            <div v-for="file in workOrderFiles" :key="file.id">
                <v-list-item class="file-item">
                    <v-list-item-content>
                        <v-list-item-title>{{ file.file_name }}</v-list-item-title>
                        <v-list-item-subtitle>
                            {{ file.created_at ? formatDateTime(file.created_at) : "" }}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-row>
                            <v-btn icon @click="downloadFile(file.id)">
                                <v-icon>file_download</v-icon>
                            </v-btn>
                            <v-btn class="pb-1" icon @click="deleteFile(file.id)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </v-row>
                    </v-list-item-action>
                </v-list-item>
                <pdf-viewer
                    v-if="getFiletype(file.file_name) === 'pdf' || getFiletype(file.file_name) === 'image'"
                    :fileId="file.id"
                    :isPdf="file.file_name.endsWith('.pdf')"
                ></pdf-viewer>
            </div>

            <v-list-item v-if="workOrderFiles.length <= 0">
                <v-list-item-content>
                    <v-list-item-title>{{ t("No files found") }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import settings from "@/settings";
import PdfViewer from "@/components/pdf-viewer.vue";
import moment from "moment/moment";
import { PermissionsConstants } from "@/permissions";

export default {
    components: { PdfViewer },
    data() {
        return {
            relatedFiles: []
        };
    },
    async mounted() {
        await this.getWorkOrderFileList();
    },
    computed: {
        ...mapState("WorkOrderStore", ["activeWorkOrder", "workOrderFiles"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        ...mapActions("WorkOrderStore", ["getWorkOrderFileList", "uploadFiles", "deleteWorkOrderFile"]),
        ...mapMutations("WorkOrderStore", ["setFileListFetched"]),
        handleFileInputClick() {
            this.$refs.fileInput.click();
        },
        async handleFileUpload(event) {
            const files = event.target.files;
            await this.uploadFiles(files);
            this.setFileListFetched(false);
            await this.getWorkOrderFileList();
        },
        downloadFile(file_id) {
            let params = "?act=download_file";
            params += "&file_id=" + file_id;
            window.location.href = settings.api_url + "/file" + params;
        },
        async deleteFile(file_id) {
            if (confirm(this.t("Are you sure you want to delete this code?"))) {
                await this.deleteWorkOrderFile(file_id);
                this.setFileListFetched(false);
                await this.getWorkOrderFileList();
            }
        },
        getFiletype(fileName) {
            const extension = fileName
                .split(".")
                .pop()
                .toLowerCase();

            if (extension === "pdf") {
                return "pdf";
            } else if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
                return "image";
            } else {
                return "other";
            }
        },
        formatDateTime(dateTimeString) {
            return moment(dateTimeString).format("DD.MM.YYYY HH:mm");
        }
    }
};
</script>

<style scoped lang="scss">
.file-upload-section {
    margin-top: 36px;
}
</style>
